import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Impressum() {
  return (
    <div data-testid="page-impressum" className="min-h-screen bg-[#F2DFC6] py-24 sm:py-32">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 lg:px-12">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-[#93401D] hover:text-[#773117] mb-10"
        >
          <ArrowLeft size={16} strokeWidth={1.5} />
          Zurück zur Startseite
        </Link>
        <div className="text-[11px] tracking-[0.3em] uppercase text-[#93401D] mb-4">Rechtliches</div>
        <h1 className="font-serif text-4xl sm:text-5xl text-[#29170C] tracking-tight">Impressum</h1>

        <div className="mt-12 space-y-8 text-[#63432B] leading-relaxed">
          <section>
            <h2 className="font-serif text-2xl text-[#29170C] mb-3">Angaben gemäß § 5 DDG</h2>
            <p>
              Witali Albrecht — Psychologische Beratung
              <br />
              Im Berge
              <br />
              44536 Lünen
              <br />
              Deutschland
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#29170C] mb-3">Kontakt</h2>
            <p>
              Telefon: +49 177 1973430
              <br />
              E-Mail: witalialbrecht21@web.de
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#29170C] mb-3">Verantwortlich für den Inhalt</h2>
            <p>Witali Albrecht (Anschrift wie oben)</p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#29170C] mb-3">Wichtiger Hinweis</h2>
            <p>
              Die angebotene psychologische Beratung stellt keine Ausübung der
              Heilkunde dar und ist keine heilkundliche Psychotherapie im Sinne
              des Heilpraktikergesetzes. Sie ersetzt keine ärztliche,
              psychiatrische oder psychotherapeutische Diagnose und Behandlung.
              Bei akuten Krisen wende dich bitte an die Telefonseelsorge
              (0800 111 0 111, kostenfrei, rund um die Uhr) oder den ärztlichen
              Bereitschaftsdienst (116 117).
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#29170C] mb-3">Haftungshinweis</h2>
            <p>
              Trotz sorgfältiger inhaltlicher Kontrolle übernehme ich keine
              Haftung für die Inhalte externer Links. Für den Inhalt der
              verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.
            </p>
          </section>

        </div>
      </div>
    </div>
  );
}
